var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.7915 5.87432C14.5915 5.84099 14.3832 5.83267 14.1665 5.83267H5.8332C5.59987 5.83267 5.37487 5.84933 5.1582 5.88266C5.27487 5.64933 5.44154 5.43269 5.64154 5.23269L8.34987 2.51602C9.49154 1.38268 11.3415 1.38268 12.4832 2.51602L13.9415 3.99098C14.4749 4.51598 14.7582 5.18266 14.7915 5.87432Z",
    stroke: "#6F7A85",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49967 15.8333C7.49967 16.4583 7.32467 17.05 7.01634 17.55C6.44134 18.5167 5.38301 19.1667 4.16634 19.1667C2.94967 19.1667 1.89134 18.5167 1.31634 17.55C1.00801 17.05 0.833008 16.4583 0.833008 15.8333C0.833008 13.9917 2.32467 12.5 4.16634 12.5C6.00801 12.5 7.49967 13.9917 7.49967 15.8333Z",
    stroke: "#6F7A85",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40814 15.8164H2.9248",
    stroke: "#6F7A85",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 14.5996V17.0913",
    stroke: "#6F7A85",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 10.0007V14.1673C18.3337 16.6673 16.667 18.334 14.167 18.334H6.35866C6.61699 18.1173 6.84199 17.8506 7.01699 17.5506C7.32533 17.0506 7.50033 16.459 7.50033 15.834C7.50033 13.9923 6.00866 12.5007 4.16699 12.5007C3.16699 12.5007 2.27533 12.9423 1.66699 13.634V10.0007C1.66699 7.73398 3.03366 6.15065 5.15866 5.88398C5.37533 5.85065 5.60033 5.83398 5.83366 5.83398H14.167C14.3837 5.83398 14.592 5.84231 14.792 5.87564C16.942 6.12564 18.3337 7.71732 18.3337 10.0007Z",
    stroke: "#6F7A85",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.3337 10.416H15.8337C14.917 10.416 14.167 11.166 14.167 12.0827C14.167 12.9993 14.917 13.7493 15.8337 13.7493H18.3337",
    stroke: "#6F7A85",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.b7d3cb9d6c4d83224e3f9398e3d84299.svg";
export { ForwardRef as ReactComponent };